export default "__VITE_ASSET__ZrhdmSc3__"